const gtmEvent = obj => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(obj)
}

export default gtmEvent
